import { PersonaConfig, PersonaOrder, OrderStatus } from "../types";

// NuPlay Fashion — Mira's crew. Generated from the seeded Supabase project
// (zqicfacynnezpwmmwhbh, fsh_* tables) so the picker and the agent always agree: if a
// number here disagrees with what the agent says on the call, that is a real finding.
// The demo beat is the LOYALTY TIER — Icon / Insider / Member get materially different
// promises for the same refund question.
export interface FashionCustomer {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  loyaltyTier: string;
  crmNotes: string;
  ordersCount: number;
  demoScenario?: string;
  orders: {
    orderId: string;
    product: string;
    /** Mapped onto the shared OrderStatus union for colour/tone only. */
    status: string;
    /** The honest words. Apparel returns and pickups do not fit retail delivery labels. */
    statusLabel?: string;
    totalUsd?: number;
    carrier?: string;
    date?: string;
  }[];
}

export const FASHION_CUSTOMERS: FashionCustomer[] = [
  {
    id: "FSH-1001",
    name: "Priya Nair",
    firstName: "Priya",
    lastName: "Nair",
    email: "priya.nair@gmail.com",
    phone: "512-555-0201",
    loyaltyTier: "Icon",
    crmNotes: "High LTV Icon member; repeat silk-dress buyer; no prior complaints.",
    ordersCount: 1,
    demoScenario: "refund_tier_contrast_icon",
    orders: [
      { orderId: "NF-40001", product: "Celeste Silk Midi Dress (M)", status: "returned", statusLabel: "Return received \u00b7 refund $248 instant", totalUsd: 248.0, carrier: "FedEx", date: "2026-08-04" },
    ],
  },
  {
    id: "FSH-1002",
    name: "Alexandra Chen",
    firstName: "Alexandra",
    lastName: "Chen",
    email: "alexandra.chen@gmail.com",
    phone: "512-555-0202",
    loyaltyTier: "Icon",
    crmNotes: "Frequent sneaker buyer; owns Runa sneakers and a Tapered Jogger; strong cross-sell fit for the Aria bomber.",
    ordersCount: 2,
    demoScenario: "exchange_cross_sell_icon",
    orders: [
      { orderId: "NF-40002", product: "Runa Knit Sneakers (7)", status: "delivered", statusLabel: "Delivered", totalUsd: 138.0, carrier: "UPS", date: "2026-08-09" },
      { orderId: "NF-40003", product: "Tapered Jogger (M)", status: "delivered", statusLabel: "Delivered", totalUsd: 98.0, carrier: "UPS", date: "2026-07-13" },
    ],
  },
  {
    id: "FSH-1003",
    name: "Marcus Webb",
    firstName: "Marcus",
    lastName: "Webb",
    email: "marcus.webb@gmail.com",
    phone: "312-555-0203",
    loyaltyTier: "Icon",
    crmNotes: "Top-tier spender; regularly asks for styling advice; good fit to demo the Icon dedicated-stylist perk.",
    ordersCount: 1,
    demoScenario: "icon_stylist_callback",
    orders: [
      { orderId: "NF-40004", product: "Marlowe Trench Coat (L)", status: "delivered", statusLabel: "Delivered", totalUsd: 268.0, carrier: "FedEx", date: "2026-08-01" },
    ],
  },
  {
    id: "FSH-1004",
    name: "Sofia Diaz",
    firstName: "Sofia",
    lastName: "Diaz",
    email: "sofia.diaz@gmail.com",
    phone: "503-555-0204",
    loyaltyTier: "Icon",
    crmNotes: "Buys drop-day releases the moment they open; flagged a price drop two days after purchase.",
    ordersCount: 1,
    demoScenario: "icon_price_adjustment",
    orders: [
      { orderId: "NF-40005", product: "Selene Wrap Dress (S)", status: "delivered", statusLabel: "Delivered", totalUsd: 172.0, carrier: "UPS", date: "2026-08-10" },
    ],
  },
  {
    id: "FSH-1005",
    name: "Jordan Blake",
    firstName: "Jordan",
    lastName: "Blake",
    email: "jordan.blake@gmail.com",
    phone: "512-555-0205",
    loyaltyTier: "Insider",
    crmNotes: "Order delayed by a warehouse stock reallocation; mildly frustrated on chat; strong candidate for a save attempt.",
    ordersCount: 1,
    demoScenario: "insider_cancellation_save",
    orders: [
      { orderId: "NF-40006", product: "Vela Trail Sneakers (10)", status: "label_created", statusLabel: "Processing", totalUsd: 164.0, date: "2026-08-14" },
    ],
  },
  {
    id: "FSH-1006",
    name: "Emma Torres",
    firstName: "Emma",
    lastName: "Torres",
    email: "emma.torres@gmail.com",
    phone: "503-555-0206",
    loyaltyTier: "Insider",
    crmNotes: "Order running behind the promised date; asked chat for a revised ETA.",
    ordersCount: 1,
    demoScenario: "insider_delivery_delay",
    orders: [
      { orderId: "NF-40007", product: "Halo Cropped Puffer (M)", status: "delayed", statusLabel: "Delayed", totalUsd: 198.0, carrier: "USPS", date: "2026-08-11" },
    ],
  },
  {
    id: "FSH-1007",
    name: "Liam Foster",
    firstName: "Liam",
    lastName: "Foster",
    email: "liam.foster@gmail.com",
    phone: "312-555-0207",
    loyaltyTier: "Insider",
    crmNotes: "Store-pickup order; chat asked whether it is ready for collection.",
    ordersCount: 1,
    demoScenario: "insider_pickup_ready",
    orders: [
      { orderId: "NF-40008", product: "Ridge Hiking Boot (11)", status: "ready_for_pickup", statusLabel: "Ready for pickup", totalUsd: 176.0, date: "2026-08-11" },
    ],
  },
  {
    id: "FSH-1008",
    name: "Nina Patel",
    firstName: "Nina",
    lastName: "Patel",
    email: "nina.patel@gmail.com",
    phone: "512-555-0208",
    loyaltyTier: "Insider",
    crmNotes: "Asked chat about the early-access window for the next seasonal drop.",
    ordersCount: 1,
    demoScenario: "insider_early_access",
    orders: [
      { orderId: "NF-40009", product: "Solstice Cashmere Sweater (S)", status: "delivered", statusLabel: "Delivered", totalUsd: 188.0, carrier: "UPS", date: "2026-07-26" },
    ],
  },
  {
    id: "FSH-1009",
    name: "Tom Rivera",
    firstName: "Tom",
    lastName: "Rivera",
    email: "tom.rivera@gmail.com",
    phone: "503-555-0209",
    loyaltyTier: "Member",
    crmNotes: "Pushed back on chat about refund speed, citing \"chat said instant\"; watch for a tier-pushback escalation.",
    ordersCount: 1,
    demoScenario: "refund_tier_contrast_member",
    orders: [
      { orderId: "NF-40010", product: "Harbor Field Jacket (L)", status: "returned", statusLabel: "Return received \u00b7 refund $189 5-7 business days", totalUsd: 189.0, carrier: "USPS", date: "2026-08-05" },
    ],
  },
  {
    id: "FSH-1010",
    name: "Grace Kim",
    firstName: "Grace",
    lastName: "Kim",
    email: "grace.kim@gmail.com",
    phone: "512-555-0210",
    loyaltyTier: "Member",
    crmNotes: "Pickup order held past the 3-day Member window; item is likely back on the sales floor.",
    ordersCount: 1,
    demoScenario: "member_pickup_hold_expired",
    orders: [
      { orderId: "NF-40011", product: "Runa Knit Sneakers (8)", status: "ready_for_pickup", statusLabel: "Ready for pickup", totalUsd: 138.0, date: "2026-08-07" },
    ],
  },
  {
    id: "FSH-1011",
    name: "Derek Hall",
    firstName: "Derek",
    lastName: "Hall",
    email: "derek.hall@gmail.com",
    phone: "312-555-0211",
    loyaltyTier: "Member",
    crmNotes: "Return request arriving well past the 30-day Member window; expect a policy-hold conversation.",
    ordersCount: 1,
    demoScenario: "member_return_outside_window",
    orders: [
      { orderId: "NF-40012", product: "Denim Straight Jean (L)", status: "delivered", statusLabel: "Delivered", totalUsd: 118.0, carrier: "FedEx", date: "2026-07-08" },
    ],
  },
  {
    id: "FSH-1012",
    name: "Maria Lopez",
    firstName: "Maria",
    lastName: "Lopez",
    email: "maria.lopez@gmail.com",
    phone: "503-555-0212",
    loyaltyTier: "Member",
    crmNotes: "Received the wrong item on her last shipment; upset on chat, needs empathetic handling and a logged case.",
    ordersCount: 1,
    demoScenario: "member_wrong_item_complaint",
    orders: [
      { orderId: "NF-40013", product: "Breeze Poplin Shirt (S)", status: "delivered", statusLabel: "Delivered", totalUsd: 88.0, carrier: "UPS", date: "2026-08-10" },
    ],
  },
];

export const FASHION_PERSONA_ID_PREFIX = "fsh_";

export function getFashionCustomer(id: string): FashionCustomer | undefined {
  return FASHION_CUSTOMERS.find((c) => c.id === id);
}

export function fashionCustomerToPersona(c: FashionCustomer): PersonaConfig {
  return {
    id: `${FASHION_PERSONA_ID_PREFIX}${c.id}`,
    name: c.name,
    role: c.crmNotes || "Customer",
    avatarInitials: ((c.firstName[0] ?? "") + (c.lastName[0] ?? "")).toUpperCase(),
    avatarBg: "",
    tagLine: c.crmNotes,
    email: c.email,
    phone: c.phone,
    accountId: c.id,
    memberSince: "",
    loyaltyTier: c.loyaltyTier,
    orders: c.orders.map((o): PersonaOrder => ({
      orderId: o.orderId,
      product: o.product,
      status: o.status as OrderStatus,
      statusLabel: o.statusLabel,
      totalUsd: o.totalUsd,
      carrier: o.carrier,
      date: o.date ?? "",
    })),
    ordersCount: c.ordersCount,
    bestFor: [],
    suggestedQuestions: {},
    crmNotes: c.crmNotes,
  };
}
